/**
 * Implementation of fourth step (Monitor alert) component
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React, { ReactNode, useState } from "react";
import { AiOutlineSlack } from "react-icons/ai";
import { FaTelegramPlane } from "react-icons/fa";
import { MdOutgoingMail, MdTextsms } from "react-icons/md";
import { SiDiscord, SiZapier } from "react-icons/si";
import { FcFeedIn } from "react-icons/fc"; 
import MetroSelect from "../MetroSelect";

const Option = ({ label, icon }: { label: string, icon: ReactNode }) => (
  <div className="bg-gray-100 flex flex-col items-center justify-center py-2 px-2 rounded-lg">
    <div className="bg-white rounded-lg w-10 h-10 flex justify-center items-center">
      { icon }
    </div>
    <p className="text-center text-gray-600 mt-2 text-sm select-none">{label}</p>
    {/* <p className="text-center text-gray-600 text-sm">{description}</p> */}
  </div>
)

const ALERTS = [
  { label: 'email', element: <Option label="E-mail" icon={<MdOutgoingMail size={32} className="text-blue-500" />} /> },
  { label: 'sms', element: <Option label="Text SMS" icon={<MdTextsms size={28} className="text-cyan-500"/>} />},
  { label: 'slack', element: <Option label="Slack" icon={<AiOutlineSlack size={30} className="text-yellow-500"/>} />},
  { label: 'telegram', element: <Option label="Telegram" icon={<FaTelegramPlane size={26} className="text-blue-400"/>} />},
  { label: 'discord', element: <Option label="Discord" icon={<SiDiscord size={28} className="text-indigo-400"/>} />},
  // { label: 'webhook', element: <Option label="Webhook" icon={<FcFeedIn size={28} />} />},
  // { label: 'Zapier', element: <Option label="zapier" icon={<SiZapier size={24} className="text-orange-500"/>} />}
]

export default function StepFour() {
  const [alert, setAlert] = useState<number[]>([])
  const [focusedMedium, setFocusedMedium] = useState("");

  function _handleSelected(selected: number | number[]) {
    
    const selectedArr = Array.from(selected as number[])
    setAlert(selectedArr)
    setFocusedMedium(ALERTS[selectedArr.at(-1) as number].label)
  }  

  return (
    <div className="">
      <p className="text-lg mb-2 mt-2 text-gray-700">You can select multiple channels</p>

      <MetroSelect multi options={ALERTS.map(a => a.element)} 
        selected={alert} onSelect={_handleSelected}
      />

      <div className="rounded-lg border border-gray-400 p-4 h-72 mt-4 mr-4">
        <p>{focusedMedium}</p>
      </div>

      <button className="btn-primary mt-4 float-right mr-4 px-8">
        Create Monitor
      </button>

    </div>
  )
}